module.exports = __webpack_public_path__ + "img/ic_24_playlist_share.b9f2ba90.svg";